import React from 'react';
import PropTypes from 'prop-types';
import { setFontSize } from 'helpers/helpers';
import NumberFormat from 'react-number-format';

const GenericDetailCard = ({title, value}) => {

  return(
    <div>
      <div className='card-wrapper'>
        <div className='text-center card-text'>
          <div className='title font-weight-bold pt-2' style={{fontSize: '16px'}}>
            {title}
          </div>
          <div
            className='value'
            style={{ fontSize: setFontSize(value) }}
          >
            <NumberFormat
              decimalScale='2'
              fixedDecimalScale
              decimalSeparator=','
              displayType='text'
              value={value}
              thousandSeparator='.'
            />
            &nbsp; UF
          </div>
        </div>
      </div>
    </div>
  )
}

GenericDetailCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
}

export default GenericDetailCard;
